module.exports = __webpack_public_path__ + "img/hero-getting-started-desktop@2x.f179d0f5.png";